module.exports = __webpack_public_path__ + "img/2_zero_hunger.8c60aa39.svg";